import React from 'react';
import { Box } from '@mui-core-real';
import { createStyles, makeStyles } from '@mui-core-real/styles';
import { StatefulSelect } from '@components/StatefulInputs/StatefulSelect/StatefulSelect';
import { StatefulRadio } from '@components/StatefulInputs/StatefulRadio/StatefulRadio';
import { StatefulTextArea } from '@components/StatefulInputs/StatefulTextArea/StatefulTextArea';
import { CancelCaseFormData } from '@components/CancelCase/CancelCaseModalTypes';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';
import { rescheduleOptions } from '@interfaces/SurgeryRequest/YesNoAnswer';

const useStyles = makeStyles((theme) =>
	createStyles({
		formWrapper: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(2),
			backgroundColor: theme.palette.background.paper,
		},
		menuPaper: {
			marginTop: theme.spacing(8),
			maxHeight: 48 * 5, // requirement to only show 5 options at a time
			borderRadius: 8,
			border: `1px solid ${theme.palette.grey[700]}`,
			boxShadow: theme.shadows[4],
		},
		cancelReasonWrapper: {
			'& .MuiOutlinedInput-root': {
				borderRadius: theme.spacing(1),
			},
		},
		cancelReasonMenu: {
			'& .MuiMenuItem-root': {
				padding: theme.spacing(1.5, 2),
				minHeight: 48,
			},
		},
		detailsWrapper: {
			width: '100%',
		},
		textAreaContainer: {
			borderRadius: theme.spacing(1),
			boxSizing: 'border-box',
			width: '100%',
			resize: 'none',
		},
	}),
);

export const CancelCaseModalForm: React.FC = () => {
	const classes = useStyles();
	const { wCancellationReasonOptions } = useSsmUiFlags();

	const reasons = wCancellationReasonOptions && wCancellationReasonOptions.length > 0
		? wCancellationReasonOptions
		: [];

	const reasonOptions = reasons.map((reason) => ({
		value: reason,
		label: reason,
	}));

	return (
		<Box className={classes.formWrapper}>
			<StatefulSelect<CancelCaseFormData>
				name="ssmCancellationReason"
				dataField="cancelCase-modal-ssmCancellationReason"
				label="Cancellation Reason"
				styleAsRequired
				wrapperClassName={classes.cancelReasonWrapper}
				options={reasonOptions}
				controllerOptions={{
					rules: {
						required: true,
					},
				}}
				MenuProps={{
					className: classes.cancelReasonMenu,
					PaperProps: {
						className: classes.menuPaper,
					},
				}}
			/>

			<StatefulRadio<CancelCaseFormData>
				name="intendToReschedule"
				dataField="cancelCase-modal-intendToReschedule"
				label="Do you plan to reschedule?"
				styleAsRequired
				options={rescheduleOptions}
				controllerOptions={{
					rules: {
						validate: (value) => value !== null,
					},
				}}
			/>

			<StatefulTextArea<CancelCaseFormData>
				name="message"
				dataField="cancelCase-modal-message"
				label="Details"
				controllerOptions={{}}
				wrapperClassName={classes.detailsWrapper}
				textAreaProps={{
					className: classes.textAreaContainer,
					minRows: 4,
				}}
			/>
		</Box>
	);
};

